import { createContext } from "react";
import type { ChatPropertiesType, SupportType } from "@b2bportal/chat-api";
import type { ChatTransfer } from "@b2bportal/ivr-api";

export type IChatSupportContext = {
  productSupportChat: (
    productId: string,
    productType: ChatPropertiesType,
    requestType: string,
    chatTransfer?: ChatTransfer
  ) => Promise<void>;
  generalSupportChat: (chatTransfer?: ChatTransfer) => Promise<void>;
  openChatWindow: () => void;
};

// Basic context that AI-assist, Kustomer, and NuChat extend
export const ChatSupportContext = createContext<Partial<IChatSupportContext>>(
  {}
);

export type IKustomerChatSupportContext = {
  setHopperUserId: (hopperUserId: string) => void;
  setKustomerAccessToken: (kustomerAccessToken: string) => void;
  unreadCount: number;
  isOpened: boolean;
  isChatCollapsed: boolean;
};

export const KustomerChatSupportContext = createContext<
  Partial<IKustomerChatSupportContext>
>({});
